export const data = [
  {
    alias: 'Lima, Ate',
    data: {
      id: 'D',
      province_name: 'Lima',
      district_name: 'Ate',
      location: 'Ate, Lima'
    }
  },
  {
    alias: 'Lima, Callao',
    data: {
      id: 'D',
      province_name: 'Lima',
      district_name: 'Callao',
      location: 'Callao, Lima'
    }
  },
  {
    alias: 'Lima, Chorrillos',
    data: {
      id: 'D',
      province_name: 'Lima',
      district_name: 'Chorrillos',
      location: 'Chorrillos, Lima'
    }
  },
  // {
  //   alias: 'Lima, Comas',
  //   data: {
  //     id: 'D',
  //     province_name: 'Lima',
  //     district_name: 'Comas',
  //     location: 'Comas, Lima'
  //   }
  // },
  {
    alias: 'Lima, Breña',
    data: {
      id: 'D',
      province_name: 'Lima',
      district_name: 'Breña',
      location: 'Breña, Lima'
    }
  },
  {
    alias: 'Lima, Jesus Maria',
    data: {
      id: 'D',
      province_name: 'Lima',
      district_name: 'Jesus Maria',
      location: 'Jesus Maria, Lima'
    }
  },
  {
    alias: 'Lima, La Molina',
    data: {
      id: 'D',
      province_name: 'Lima',
      district_name: 'La Molina',
      location: 'La Molina, Lima'
    }
  },
  {
    alias: 'Lima, La Victoria',
    data: {
      id: 'D',
      province_name: 'Lima',
      district_name: 'La Victoria',
      location: 'La Victoria, Lima'
    }
  },
  // {
  //   alias: 'Lima, La Molina',
  //   data: {
  //     id: 'D',
  //     province_name: 'Lima',
  //     district_name: 'La Molina',
  //     location: 'La Molina, Lima'
  //   }
  // },
  {
    alias: 'Lima, Lima',
    data: {
      id: 'D',
      province_name: 'Lima',
      district_name: 'Lima',
      location: 'Lima, Lima'
    }
  },
  {
    alias: 'Lima, Lince',
    data: {
      id: 'D',
      province_name: 'Lima',
      district_name: 'Lince',
      location: 'Lince, Lima'
    }
  },
  // {
  //   alias: 'Lima, Los Olivos',
  //   data: {
  //     id: 'D',
  //     province_name: 'Lima',
  //     district_name: 'Los Olivos',
  //     location: 'Los Olivos, Lima'
  //   }
  // },
  {
    alias: 'Lima, Miraflores',
    data: {
      id: 'D',
      province_name: 'Lima',
      district_name: 'Miraflores',
      location: 'Miraflores, Lima'
    }
  },
  {
    alias: 'Lima, Puente Piedra',
    data: {
      id: 'D',
      province_name: 'Lima',
      district_name: 'Puente Piedra',
      location: 'Puente Piedra, Lima'
    }
  },
  {
    alias: 'Lima, S.M.Porres',
    data: {
      id: 'D',
      province_name: 'Lima',
      district_name: 'S.M.Porres',
      location: 'San Martin de Porres, Lima'
    }
  },
  // {
  //   alias: 'Lima, San Borja',
  //   data: {
  //     id: 'D',
  //     province_name: 'Lima',
  //     district_name: 'San Borja',
  //     location: 'San Borja, Lima'
  //   }
  // },
  // {
  //   alias: 'Lima, San Isidro',
  //   data: {
  //     id: 'D',
  //     province_name: 'Lima',
  //     district_name: 'San Isidro',
  //     location: 'San Isidro, Lima'
  //   }
  // },
  // {
  //   alias: 'Lima, San Miguel',
  //   data: {
  //     id: 'D',
  //     province_name: 'Lima',
  //     district_name: 'San Miguel',
  //     location: 'San Miguel, Lima'
  //   }
  // },
  {
    alias: 'Lima, Santa Anita',
    data: {
      id: 'D',
      province_name: 'Lima',
      district_name: 'Santa Anita',
      location: 'Santa Anita, Lima'
    }
  },
  {
    alias: 'Lima, Surco',
    data: {
      id: 'D',
      province_name: 'Lima',
      district_name: 'Surco',
      location: 'Surco, Lima'
    }
  },
  // {
  //   alias: 'Lima, Surquillo',
  //   data: {
  //     id: 'D',
  //     province_name: 'Lima',
  //     district_name: 'Surquillo',
  //     location: 'Surquillo, Lima'
  //   }
  // },
  // {
  //   alias: 'Huamanga, Huamanga',
  //   data: {
  //     id: 'D',
  //     province_name: 'Huamanga',
  //     district_name: 'Huamanga',
  //     location: 'Huamanga, Huamanga'
  //   }
  // },
  // {
  //   alias: 'Huamanga, Huancayo',
  //   data: {
  //     id: 'D',
  //     province_name: 'Huamanga',
  //     district_name: 'Huancayo',
  //     location: 'Huancayo, Huamanga'
  //   }
  // },
  // {
  //   alias: 'Huancayo, Huancayo',
  //   data: {
  //     id: 'D',
  //     province_name: 'Huancayo',
  //     district_name: 'Huancayo',
  //     location: 'Huancayo, Huancayo'
  //   }
  // },
  // {
  //   alias: 'Ica, Ica',
  //   data: {
  //     id: 'D',
  //     province_name: 'Ica',
  //     district_name: 'Ica',
  //     location: 'Ica, Ica'
  //   }
  // },
  // {
  //   alias: 'Trujillo, Trujillo',
  //   data: {
  //     id: 'D',
  //     province_name: 'Trujillo',
  //     district_name: 'Trujillo',
  //     location: 'Trujillo, Trujillo'
  //   }
  // },
  // {
  //   alias: 'Arequipa, Arequipa',
  //   data: {
  //     id: 'D',
  //     province_name: 'Arequipa',
  //     district_name: 'Arequipa',
  //     location: 'Arequipa, Arequipa'
  //   }
  // },
  // {
  //   alias: 'Chiclayo, Chiclayo',
  //   data: {
  //     id: 'D',
  //     province_name: 'Chiclayo',
  //     district_name: 'Chiclayo',
  //     location: 'Chiclayo, Chiclayo'
  //   }
  // },
  // {
  //   alias: 'Piura, Piura',
  //   data: {
  //     id: 'D',
  //     province_name: 'Piura',
  //     district_name: 'Piura',
  //     location: 'Piura, Piura'
  //   }
  // }
];
